let navigator;
export const setNavigator = (nav) => {
  navigator = nav;
};
// global navigation function
export const navigateTo = (path, options = {}) => {
  if (navigator) {
    navigator(path, options);
  } else {
    console.error("Navigator is not set yet!");
  }
};
